import React, { useEffect, useState } from "react";
import { object } from "prop-types";

import { Row, Col } from "reactstrap";
import "./AllClientDetails.css";

import SingleClientReportDetailsTable from "../../single-client-details/client-info-table";
import LinkedClientsTable from "../../single-client-details/linked-clients-details";

import ClientScoringInputParameters from "../../single-client-details/scoring-input-parameters-table";

import ScorecardCalculatedParametersTable from "../../single-client-details/scorecard-calculated-parameters-table";
import FalsePositiveInfoTable from "../../single-client-details/false-positive-Info-table";
import TrueMatchesInfoTable from "../../single-client-details/true-matches-info-table";

import NegativeMediaIgnoringPropertiesTable from "../../single-client-details/negative-media-ignoring-properties";
import CollapseTables from "./CollapseTables";
import { useDispatch, useSelector } from "react-redux";
import { singleClientReportCollapsesClosed } from "../../../selectors";
import { toggleCollapsesClosedSingleClientReport } from "../../../actions";
import ScoringResultHistoryTable from "../scoring-result-history-table/ScoringResultHistoryTable";

const AllClientDetails = ({
  singleClientReportDetails,
  showCompanyDetails,
}) => {
  const dispatch = useDispatch();

  const anyCollapseOpen = useSelector(singleClientReportCollapsesClosed);

  const [collapsesState, setCollapsesState] = useState({
    riskOpen: false,
    mediaOpen: false,
    scoreHistoryOpen: false,
  });

  const toggleRiskCollapse = () => {
    if (!anyCollapseOpen) {
      dispatch(toggleCollapsesClosedSingleClientReport());
    }
    setCollapsesState({
      ...collapsesState,
      riskOpen: !collapsesState.riskOpen,
    });
  };

  const toggleMediaCollapse = () => {
    if (!anyCollapseOpen) {
      dispatch(toggleCollapsesClosedSingleClientReport());
    }
    setCollapsesState({
      ...collapsesState,
      mediaOpen: !collapsesState.mediaOpen,
    });
  };

  const toggleScoreHistoryCollapse = () => {
    if (!anyCollapseOpen) {
      dispatch(toggleCollapsesClosedSingleClientReport());
    }
    setCollapsesState({
      ...collapsesState,
      scoreHistoryOpen: !collapsesState.scoreHistoryOpen,
    });
  };

  useEffect(() => {
    if (!anyCollapseOpen) {
      setCollapsesState({
        riskOpen: false,
        mediaOpen: false,
      });
    }
  }, [anyCollapseOpen]);

  return (
    <Row className="mb-5 ">
      {singleClientReportDetails.linkedClients.length > 0
        ? !showCompanyDetails && (
            <Col lg={12}>
              <LinkedClientsTable
                singleClientReportDetails={singleClientReportDetails}
              />
            </Col>
          )
        : null}
      {showCompanyDetails ? (
        <Col lg={12} className="p-0">
          <SingleClientReportDetailsTable
            singleClientReportDetails={singleClientReportDetails}
          />
        </Col>
      ) : null}

      {showCompanyDetails ? (
        <CollapseTables
          open={collapsesState.riskOpen}
          toggle={toggleRiskCollapse}
          title={
            singleClientReportDetails.scoringInputDataLabel +
            " / " +
            singleClientReportDetails.scoringValueOfEachParameterLabel
          }
        >
          <Row className="bg-white mt-2 p-4">
            <Col lg={6}>
              <span className="tabletitle">
                {singleClientReportDetails.scoringInputDataLabel}
              </span>
              <ClientScoringInputParameters
                singleClientReportDetails={singleClientReportDetails}
              />
            </Col>

            <Col lg={6}>
              <span className="tabletitle">
                {singleClientReportDetails.scoringValueOfEachParameterLabel}
              </span>
              <ScorecardCalculatedParametersTable
                singleClientReportDetails={singleClientReportDetails}
              />
            </Col>
          </Row>
        </CollapseTables>
      ) : null}

      {showCompanyDetails ? (
        <CollapseTables
          open={collapsesState.mediaOpen}
          toggle={toggleMediaCollapse}
          title={`${singleClientReportDetails.falsePositivesLabel} / ${singleClientReportDetails.trueMatchesLabel} / ${singleClientReportDetails.negativeMediaLabel}`}
        >
          <div className="bg-white mt-2 p-4">
            <Col lg={12}>
              <span className="tabletitle">
                {singleClientReportDetails.falsePositivesLabel}
              </span>
              <FalsePositiveInfoTable
                singleClientReportDetails={singleClientReportDetails}
              />
            </Col>

            <Col lg={12}>
              <span className="tabletitle">
                {singleClientReportDetails.trueMatchesLabel}
              </span>
              <TrueMatchesInfoTable
                singleClientReportDetails={singleClientReportDetails}
              />
            </Col>

            <Col lg={12}>
              <span className="tabletitle">
                {singleClientReportDetails.negativeMediaLabel}
              </span>
              <NegativeMediaIgnoringPropertiesTable
                singleClientReportDetails={singleClientReportDetails}
              />
            </Col>
          </div>
        </CollapseTables>
      ) : null}

      {showCompanyDetails ? (
        <CollapseTables
          open={collapsesState.scoreHistoryOpen}
          toggle={toggleScoreHistoryCollapse}
          title={`${singleClientReportDetails.clientScoringResultHistoryAndCommentsLabel}`}
        >
          <div className="bg-white mt-2 p-4">
            <Col lg={12} className="p-0">
              <ScoringResultHistoryTable
                singleClientReportDetails={singleClientReportDetails}
              />
            </Col>
          </div>
        </CollapseTables>
      ) : null}
    </Row>
  );
};

AllClientDetails.propTypes = {
  singleClientReportDetails: object.isRequired,
};

export default AllClientDetails;



// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/all-client-details/AllClientDetails.jsx